import { Form, Formik } from 'formik';
import { noop } from 'lodash';
import { ReactElement } from 'react';
import { SingleValue } from 'react-select';
import { useAppDispatch } from '../../redux/hooks';
import { setDQDFilter, setSchoolFilter } from '../../redux/slices/dataQualitySlice';
import { DataQualityFilterPropTypes } from '../../types/propTypes/DataQualityFilterPropTypes';
import { ReactSelectOption } from '../../types/ReactSelectOption';
import FormDropdown from '../FormInputs/FormDropdown/FormDropdown';
import './DataQualityFilter.css';

const DataQualityFilter = ({
  dataCollectionValue,
  dataCollectionOptions,
  schoolValue,
  schoolOptions
}: DataQualityFilterPropTypes): ReactElement => {
  const dispatch = useAppDispatch();

  const handleCollectionChange = (
    selected: SingleValue<ReactSelectOption>
  ): Promise<void> => {
    /* istanbul ignore next */
    const getValue = selected?.value || '';

    dispatch(setDQDFilter(getValue));
    return Promise.resolve();
  };

  const handleSchoolChange = (
    selected: SingleValue<ReactSelectOption>
  ): Promise<void> => {
    /* istanbul ignore next */
    const getValue = selected?.value || '';
    dispatch(setSchoolFilter(getValue));
    return Promise.resolve();
  };

  return (
    <div className="data-quality-filter-container">
      <Formik
        initialValues={{
          dataCollectionName: dataCollectionValue,
          schoolName: schoolValue
        }}
        onSubmit={
          /* istanbul ignore next */
          () => noop()
        }
      >
        <Form>
          <div className="display-flex">
            <div className="dropdown-min-width">
              <FormDropdown
                displayName="Certification Data Collection"
                field="dataCollectionName"
                options={dataCollectionOptions}
                onChange={handleCollectionChange}
                isClearable
              />
            </div>
            <div className="dropdown-min-width">
              <FormDropdown
                displayName="School"
                field="schoolName"
                options={schoolOptions}
                onChange={handleSchoolChange}
                isClearable
              />
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default DataQualityFilter;
